export const getPhoneNumberToPlainNumber = (
  phoneNumber: string | null | undefined,
): string => {
  if (!phoneNumber) return '';
  return phoneNumber.replace(/\D/g, '');
};
